const modals = {
  id: null,
  deadlineDate: null,
  orderMode: null,
  placeOrderTime: null,
  placeOrderUserName: null,
  productList: null,
  purchaseOrderNumber: null,
  remark: null,
  shopCode: null,
  shopName: null,
};
export default modals;
